module.exports = __webpack_public_path__ + "img/16_ingresos.d7d19365.png";